import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import SzukajSearchbox from "./components/SzukajSearchbox";
import MiejscowosciService from "../../trasyConfig/miejscowosci/MiejscowosciService";
import BezPrzesiadkiTable from "./components/BezPrzesiadkiTable";
import ZPrzesiadkaTable from "./components/ZPrzesiadkaTable";
import ClientApi from "../../biletyConfig/biletyApi/ClientService";
import TopIf from "../../../../componentsTopsa/if/TopIf";

export default class SzukajContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            miejscowosci: [],
            rekordy: [],
            czyByloSzukanie: false,
            czyPokazacLoader: true,
        };
        this.onClickWyszukaj = this.onClickWyszukaj.bind(this)
    }

    componentDidMount() {
        this.pobierzMiejscowosci()
    }

    pobierzMiejscowosci() {
        MiejscowosciService.getMiejscowosci().then(function (response) {
            this.setState({miejscowosci: response.data.content})
        }.bind(this))
    }

    onClickWyszukaj(obj) {
        this.setState({czyByloSzukanie: true, czyPokazacLoader: true})
        ClientApi.getKursyMiedzyPrzystankamiWDanymCzasie(obj).then(function (response) {
            this.setState({rekordy: response.data, czyPokazacLoader: false})
        }.bind(this))
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RozkladContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/rozklad-jazdy',
                                    text: 'Rozkład jazdy'
                                }, {addressUrl: '/konfiguracja/rozklad-jazdy/szukaj', text: 'Szukaj'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <SzukajSearchbox miejscowosci={this.state.miejscowosci} handleClickWyszukaj={this.onClickWyszukaj}/>
                        </Col>
                        <Col sm={12} style={{marginTop: '15px'}}>
                            {
                                Boolean(this.state.czyByloSzukanie) ?
                                    Boolean(this.state.czyPokazacLoader) ?
                                        <div id={'smallLoader'}>
                                            <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                            <div>Trwa wyszukiwanie wyników...</div>
                                        </div>
                                        :
                                        Boolean(this.state.rekordy.length > 0) ?
                                            Boolean(this.state.rekordy[0].nazTrPrze) ?
                                                <ZPrzesiadkaTable data={this.state.rekordy}/>
                                                :
                                                <BezPrzesiadkiTable data={this.state.rekordy}/>
                                            :
                                            'Brak pasujących rekordów'
                                    :
                                    ''
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/szukaj/SzukajContainer.js